import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// gm账号列表
interface GmAccountData {
  token: string;
}

export const GmAccount = (json: GmAccountData): any =>
  http.httpPost({
    url: httpApi.settlement.GmAccount,
    json,
  });

// 结算审核列表
interface SettlementListData {
  token: string;
  game_name: string;
  order_num: string;
  account: string;
  type: string;
  page: number;
  pagenum: number;
}

export const settlementList = (json: SettlementListData): any =>
  http.httpPost({
    url: httpApi.settlement.settlementList,
    json,
  });

// 结算操作（通过，失败）
interface SettlementOperationData {
  token: string;
  type: number;
  ids: string;
  remark: string;
}

export const settlementOperation = (json: SettlementOperationData): any =>
  http.httpPost({
    url: httpApi.settlement.settlementOperation,
    json,
  });

// 结算申请列表
interface SettlementApplyListData {
  token: string;
  game_name: string;
  account: string;
  page: number;
  pagenum: number;
}

export const settlementApplyList = (json: SettlementApplyListData): any =>
  http.httpPost({
    url: httpApi.settlement.settlementApplyList,
    json,
  });

// 申请结算
interface SettlementOrderData {
  token: string;
  id: string;
  type: number;
}

export const settlementOrder = (json: SettlementOrderData): any =>
  http.httpPost({
    url: httpApi.settlement.settlementOrder,
    json,
  });

// 结算记录
interface SettlementLogData {
  token: string;
  page: number;
  pagenum: number;
  game_name: string;
  account: string;
  status: string;
}

export const settlementLog = (json: SettlementLogData): any =>
  http.httpGet({
    url: httpApi.settlement.settlementLog,
    json,
  });
